import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "gkn_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// ---- Public reads ----
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getTrust = () => api.get("/trust").then((r) => r.data);
export const getDigitalCard = () => api.get("/digital-card").then((r) => r.data);
export const getResolvedIssues = () => api.get("/resolved-issues").then((r) => r.data);
export const getMilestones = () => api.get("/milestones").then((r) => r.data);
export const getAwards = () => api.get("/awards").then((r) => r.data);
export const getLeadershipRoles = () => api.get("/leadership-roles").then((r) => r.data);
export const getGallery = () => api.get("/gallery").then((r) => r.data);
export const getMedia = () => api.get("/media").then((r) => r.data);
export const getFacts = () => api.get("/facts").then((r) => r.data);
export const getSocialWork = (category) =>
  api.get("/social-work", { params: category ? { category } : {} }).then((r) => r.data);
export const getSocialWorkDetail = (slug) => api.get(`/social-work/${slug}`).then((r) => r.data);
export const getPageSeo = (slug) => api.get(`/page-seo/${slug}`).then((r) => r.data);

// ---- Public forms ----
export const submitWardIssue = (data) => api.post("/ward-issues", data).then((r) => r.data);
export const trackWardIssue = (ref) =>
  api.get(`/ward-issues/track/${encodeURIComponent(ref)}`).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitJoinMovement = (data) => api.post("/join-movement", data).then((r) => r.data);

// ---- Auth ----
export const login = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);

// ---- Admin generic ----
export const adminList = (resource) => api.get(`/admin/${resource}`).then((r) => r.data);
export const adminCreate = (resource, data) => api.post(`/admin/${resource}`, data).then((r) => r.data);
export const adminUpdate = (resource, id, data) => api.put(`/admin/${resource}/${id}`, data).then((r) => r.data);
export const adminDelete = (resource, id) => api.delete(`/admin/${resource}/${id}`).then((r) => r.data);

export const getDashboard = () => api.get("/admin/dashboard").then((r) => r.data);
export const adminGetSettings = () => api.get("/settings").then((r) => r.data);
export const adminUpdateSettings = (data) => api.put("/admin/settings", data).then((r) => r.data);
export const adminGetTrust = () => api.get("/trust").then((r) => r.data);
export const adminUpdateTrust = (data) => api.put("/admin/trust", data).then((r) => r.data);
export const adminWardIssues = (params) => api.get("/admin/ward-issues", { params }).then((r) => r.data);
export const adminUpdateWardIssue = (id, data) => api.put(`/admin/ward-issues/${id}`, data).then((r) => r.data);
export const adminDeleteWardIssue = (id) => api.delete(`/admin/ward-issues/${id}`).then((r) => r.data);
export const adminUploadImage = (data) => api.post("/admin/images", { data }).then((r) => r.data);
export const adminUpdateDigitalCard = (data) => api.put("/admin/digital-card", data).then((r) => r.data);
export const adminUpdateBiography = (data) => api.put("/admin/biography", data).then((r) => r.data);
export const getBiography = () => api.get("/biography").then((r) => r.data);
export const SHARE_IMAGE_URL = `${BACKEND_URL}/api/digital-card/share-image`;
export const resolvedImageUrl = (ref) => `${API}/ward-issues/${encodeURIComponent(ref)}/resolved-image`;
export const adminContacts = () => api.get("/admin/contact-inquiries").then((r) => r.data);
export const adminJoins = () => api.get("/admin/join-movements").then((r) => r.data);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
